export default {"src":"/_next/static/media/logo-color.8dc4eb5a.svg","height":52,"width":185};